<template>
  <el-form :model="ruleForm" ref="ruleForm" label-position="right" label-width="120px">
    <el-form-item :label="$t('licenca')">
      <CustomerList v-model="ruleForm.customer" :customerType="2" :multiple="true" @selected="list" />
    </el-form-item>
    <MessageAddTableUsers ref="tableUsers" />
  </el-form>
</template>

<script>
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import MessageAddTableUsers from "./MessageAddTableUsers.vue";

export default {
  name: 'MessageAddUsersLicence',
  components: {
    CustomerList,
    MessageAddTableUsers
  },
  data: function () {
    return {
      ruleForm: {
        customer: [],
        name: [],
      },
    };
  },
  methods: {
    list(customer, name) {
      this.ruleForm.name = name;
      this.$refs.tableUsers.show(customer, '1')
    },
    get() {
      const vm = this;
      const userSeleteds = this.$refs.tableUsers.get();
      if (this.ruleForm.customer.length === 0) {
        return [{ type: 'license', value: 'license', label: "Todas licenças" }]
      } else if (userSeleteds.length === 0) {
        return this.ruleForm.customer.map((x, index) => {
          return {
            type: 'license',
            value: x,
            label: vm.ruleForm.name[index]
          }
        })
      }
      return userSeleteds.map(x => {
        return {
          type: 'user',
          value: x.id,
          label: x.name,
        }
      });
    }
  }
};
</script>